import * as env from 'env';

export function printEnv() {
    !env.isProd && console.log('ENV', env);
}

printEnv();
